type OptionType = {
	value: number | string;
	text: string;
}

export const getDayOptionsForMonthYear = (monthStr: string, yearStr: string) => {
	const month = parseInt(monthStr, 10);
	const year = parseInt(yearStr, 10);

	if (
		isNaN(month) || month < 1 || month > 12 ||
		isNaN(year) || year < 1
	) {
		return Array.from({ length: 31 }, (_, i) => ({
			value: String(i + 1),
			text: String(i + 1),
		}));
	}

	const daysInMonth = new Date(year, month, 0).getDate();

	return Array.from({ length: daysInMonth }, (_, i) => ({
		value: String(i + 1),
		text: String(i + 1),
	}));
}

export const getDayOptions = () => {
	const dayArray: OptionType[] = [];
	for (let i = 1; i <= 31; i++) {
		dayArray.push({ value: String(i), text: `${i}` });
	}
	return dayArray;
};

export const getLocaleMonthOptions = (locale: string = navigator.language) => {
	const monthOptions: OptionType[] = [];
	const formatter = new Intl.DateTimeFormat(locale, { month: 'long' });
	const months = Array.from({ length: 12 }, (_, i) =>
		formatter.format(new Date(new Date().getFullYear(), i, 1))
	);

	months.map((month, index) => {
		monthOptions.push({ value: String(index + 1), text: `${month}` })
	})
	return monthOptions;
};

export const getYearsOptions = () => {
	const currentYear = new Date().getFullYear();
	const years: OptionType[] = [];

	for (let year = 1930; year <= currentYear; year++) {
		years.push({ value: String(year), text: `${year}` });
	}

	return years.reverse();
}